import React from 'react';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ListItem from '../../../../layout/MenuList/ListItem/ListItem';
import ListCollapse from '../../../../layout/MenuList/ListCollapse/ListCollapse';
import useEventSidebar from './useEventSidebar';
import '../../../../styles/components/Sidebar.css';

function EventSidebar() {
    const { mainTabs, isItemSelected, selectedItems, settingTabs } = useEventSidebar();

    return (
        <React.Fragment>
            <aside id="event-dashboard-sidebar">
                <div className="go-back-container">
                    <Button
                        fullWidth
                        size="large"
                        variant="text"
                        sx={backBtnStyle}
                        startIcon={<ArrowBackIcon />}
                        onClick={() => window.history.back()}
                    >
                        Back
                    </Button>
                </div>
                <div className="event-dashboard-tabs-container">
                    <div className="event-dashboard-main-tabs">
                        {mainTabs.map((item) => {
                            if (item.type === 'item') {
                                return (
                                    <ListItem
                                        key={item.id}
                                        tabName={item.title}
                                        icon={item.icon}
                                        url={item.url}
                                        isSelected={isItemSelected(item)}
                                        shouldEnabledMenu={!item.enabled}
                                    />
                                );
                            } else if (item.type === 'collapse') {
                                const hasEnabledChild = !item.children.some(
                                    (child) => child.enabled
                                );
                                return (
                                    <ListCollapse
                                        key={item.id}
                                        tabName={item.title}
                                        icon={item.icon}
                                        children={item.children}
                                        selectedChildUrl={selectedItems.childSelectedUrl}
                                        shouldEnabledMenu={hasEnabledChild}
                                    />
                                );
                            }
                            return null;
                        })}
                    </div>
                    <div className="event-settings-log-out-tabs">
                        <div className="event-setting-tabs">
                            {settingTabs.map((item) => (
                                <ListItem
                                    key={item.id}
                                    tabName={item.title}
                                    icon={item.icon}
                                    url={item.url}
                                    isSelected={item.id === selectedItems.settingSelected}
                                    shouldEnabledMenu={!item.enabled}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </aside>
        </React.Fragment>
    );
}

export default EventSidebar;

const backBtnStyle = {
    color: '#f5f5f5',
    textTransform: 'capitalize',
    fontFamily: 'Nunito, sans-serif',
    fontSize: '1.25rem',
    justifyContent: 'flex-start',
    borderRadius: '0.625rem'
};
